import React from 'react'

const SvgPlusCircleFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11.725 2c-5.523 0-10 4.477-10 10 0 5.522 4.477 10 10 10s10-4.478 10-10c0-5.523-4.477-10-10-10zm-4 9h2.998V8h2v3h3.002v2h-3.002v3h-2v-3H7.725v-2z'
    />
  </svg>
)

export default SvgPlusCircleFilled
